import { userListHeaderStyles } from "@insite/content-library/Widgets/UserList/UserListHeader";
import { css } from "styled-components";

Object.assign(userListHeaderStyles, {
    ...userListHeaderStyles,
    buttonsGridItem: {
        css: css`
            justify-content: flex-end;
            align-items: flex-end;
            button[data-test-selector="userListHeader_createNewUser"] {
                padding: 11px 19px;
            }
            span {
                font-size: 16px;
                text-transform: none;
            }
        `,
        width: [2, 2, 4, 3, 3],
    },
    searchSubmitButton: {
        css: css`
            flex: 0 0 auto;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
        variant: "primary",
    },
    userCountText: {
        css: css`
            font-family: neuronRegular;
        `,
    },
});
